import React from "react";
import styled from "styled-components";
import Group7066 from "../../img/gps/group-7066.svg";
import Group7068 from "../../img/gps/group-7068.png";
import Group7070 from "../../img/gps/group-7070.png";
import Group7260 from "../../img/gps/group-7260.svg";

const GpsFirstContentWrapper = styled.div`
  padding: 0px 375px;
  margin-bottom: -115px;
  position: relative;
  z-index: 1;
  .container {
    padding: 100px;
    box-shadow: 0px 4px 20px #1a284d14;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    background-color: #fff;
    .container-cards {
      display: flex;
      align-items: center;
      .left {
        flex-basis: 75%;

        h2 {
          ${(props) => props.theme.h2_48};
          color: #202945;
          margin-bottom: 16px;
        }
        p {
          ${(props) => props.theme.body_20};
        }
      }

      .right {
        img {
          width: 370px;
          display: block;
        }
      }
      &:nth-child(2n) {
        .left {
          order: 1;
          margin-right: 0;
          margin-left: 30px;
        }
      }
      &:not(:last-child) {
        margin-bottom: 120px;
      }
      &:last-child {
        img {
          box-shadow: none;
        }
      }
    }
  }
  @media (max-width: 1900px) {
    padding: 0px 275px;
    .container {
      padding: 30px 25px 40px;
      .container-cards {
        .left {
          h2 {
            font-size: 38px;
            line-height: 53px;
          }
          p {
            font-size: 18px;
            line-height: 25px;
          }
        }
        &:not(:last-child) {
          margin-bottom: 75px;
        }
      }
    }
  }

  @media (max-width: 1439px) {
    padding: 0px 50px;
  }
  @media (max-width: 1023px) {
    padding: 0px 20px;
    .container {
      .container-cards {
        .left {
          h2 {
            font-size: 28px;
            line-height: 39px;
          }
          p {
            font-size: 15px;
            line-height: 21px;
          }
        }
        .right {
          img {
            width: 250px;
          }
        }
      }
    }
  }

  @media (max-width: 767px) {
    .container {
      padding: 30px 15px 40px;
      .container-cards {
        display: block;
        .left {
          margin-right:0;
          margin-bottom:15px;
          h2 {
            font-size: 28px;
            line-height: 39px;
            margin-bottom:10px;
          }
          p {
            font-size: 15px;
            line-height: 21px;
          }
        }
        .right {
          img {
            margin: 0 auto;
          }
        }
        &:nth-child(2n) {
          .left {
            margin-left: 0;
          }
        }
        &:not(:last-child) {
          margin-bottom: 40px;
        }
      }
    }
  }
`;
const GpsFirstContent = () => {
  return (
    <GpsFirstContentWrapper>
      <div className="container">
        <div className="container-cards">
          <div className="left">
            <h2 className="t" data-translate="GPSFirstContentFirstCardTitle">Real-Time GPS location</h2>
            <p className="t" data-translate="GPSFirstContentFirstCardText">See the exact location of all your vehicles in real-time</p>
          </div>
          <div className="right">
            <img alt="" src={Group7066} />
          </div>
        </div>
        <div className="container-cards">
          <div className="left">
            <h2 className="t" data-translate="GPSFirstContentSecondCardTitle">Current Route and Speed</h2>
            <p className="t" data-translate="GPSFirstContentSecondCardText">
              Check your drivers' route choice and speed to ensure precise
              driving and being on schedule.
            </p>
          </div>
          <div className="right">
            <img alt="" src={Group7068} />
          </div>
        </div>
        <div className="container-cards">
          <div className="left">
            <h2 className="t" data-translate="GPSFirstContentThirdCardTitle">Driver's Data on Display</h2>
            <p className="t" data-translate="GPSFirstContentThirdCardText">
              Being able to see the drivers' current driving time, distance
              driven, rest periods and tachograph prediction helps with planning
              and assigning tasks.
            </p>
          </div>
          <div className="right">
            <img alt="" src={Group7070} />
          </div>
        </div>
        <div className="container-cards">
          <div className="left">
            <h2 className="t" data-translate="GPSFirstContentFourthCardTitle">Fuel Monitoring to Improve Planning</h2>
            <p className="t" data-translate="GPSFirstContentFourthCardText">
              Live data on the fleet fuel consumption will help you to compare
              your vehicle performance and help to plan routes and manage
              drivers' tasks more efficiently.
            </p>
          </div>
          <div className="right">
            <img alt="" src={Group7260} />
          </div>
        </div>
      </div>
    </GpsFirstContentWrapper>
  );
};

export default GpsFirstContent;
